import React from 'react';

import {
  FeedbackContainer,
  FeedbackImage,
  FeedbackTitle,
  FeedbackSubtitle,
  FeedbackButton,
} from '@/components/Template/Feedback';

import LinkFAQ from '@/components/Shared/LinkFAQ';
import useError from './Error.hook';

const Error: React.FC = () => {
  const { paymentId, errorConfig, handleClick } = useError();

  return (
    <FeedbackContainer>
      <FeedbackImage src={errorConfig.img} alt="Imagem de erro" />
      <FeedbackTitle>{errorConfig.title}</FeedbackTitle>
      <FeedbackSubtitle>{errorConfig.description}</FeedbackSubtitle>
      {paymentId && (
        <FeedbackButton
          className="checkout_botaotentarnovamente1_linkblu"
          onClick={handleClick}
        >
          {errorConfig.buttonText}
        </FeedbackButton>
      )}
      {errorConfig.faq && <LinkFAQ faq={errorConfig.faq} />}
    </FeedbackContainer>
  );
};

export default Error;
